
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { IDENTITY_INTEGRATION_STATUS_ACTIVE } from '@/services/identityIntegrationsService';

@Component({ name: 'IntegrationStatusPill' })
export default class IntegrationStatusPill extends Vue {
  @Prop({ required: true })
  protected status!: string;

  get isActive(): boolean {
    return this.status === IDENTITY_INTEGRATION_STATUS_ACTIVE;
  }

  get label(): string {
    return this.isActive
      ? (this.$t('identityIntegrations.status.active') as string)
      : (this.$t('identityIntegrations.status.inactive') as string);
  }
}
